import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import moment from 'moment';
import { Card, Empty } from 'antd';

const transformFiledToLabel = (fieldName) => {
    return fieldName.replace('_', '/').replace('qty', 'ltr')
}

am4core.useTheme(am4themes_animated);

function FuelConsumptionChart({ data: docs, assetData, selectedGroup, chartUnit = 'hours', loading, processDataWithGroups, ...props }) {
    const [data, setData] = useState([]);
    const [header, setHeader] = useState('--');

    // useEffect(() => {
    //     setData(docs)
    // }, [docs]);

    // useLayoutEffect(() => {
    //     if (assetData) {
    //         setHeader(`Daywise fuel quantity chart for asset ${assetData.assetCode}`)
    //     }
    // }, [assetData])

    useLayoutEffect(() => {
        // console.log(selectedGroup);
        const group = processDataWithGroups(docs, selectedGroup)
        console.log('group', group);
        setData(group)
        // setData(docs)
    }, [docs, selectedGroup])

    // useEffect(() => {
    //     console.log(data);
    // }, [data]);


    useLayoutEffect(() => {
        if (selectedGroup && assetData) {
            const title = selectedGroup === 'w' ? 'Weekly' : selectedGroup === 'm' ? 'Monthwise' : selectedGroup === 'y' ? 'Yearwise' : 'Daywise';
            setHeader(`${title} fuel consumption for ${assetData.assetCode}`)
        }
    }, [selectedGroup, assetData]);

    const chart = useRef(null);

    useLayoutEffect(() => {
        if (!loading && data && data.length) {

            let totalFuel = 0;
            data.forEach(d => {
                totalFuel += Number(d.quantity)
            })

            // am4core.addLicense("ch-custom-attribution");
            let x = am4core.create("fuelConsumed", am4charts.XYChart);

            let title = x.titles.create();
            title.text = header;
            title.fontSize = 15;
            title.marginBottom = 18;

            // Export
            x.exporting.menu = new am4core.ExportMenu();
            x.exporting.filePrefix = "fuel_consume_data_" + new Date().getTime();

            x.paddingRight = 20;

            let dateAxis = x.xAxes.push(new am4charts.CategoryAxis());
            // dateAxis.dataFields.category = "date";
            dateAxis.dataFields.category = 'date';
            // dateAxis.title.text = "Date"
            dateAxis.title.text = selectedGroup === 'm' ? 'Month' : selectedGroup === 'w' ? 'Week' : selectedGroup === 'y' ? 'Year' : 'Date Range';
            // dateAxis.title.rotation = -90;
            // dateAxis.renderer.minGridDistance = 10;
            // dateAxis.title.fill = am4core.color("#ff0000");
            // dateAxis.title.align = "left"; // Align the title to the left
            // dateAxis.title.valign = "top"; // Vertically align the title to the top
            // dateAxis.title.dy = -30; // Adjust the y position
            // dateAxis.renderer.labels.template.rotation = -90;

            let valueAxis = x.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text = 'Fuel quantity (ltr)'
            valueAxis.renderer.line.strokeOpacity = 1;
            valueAxis.renderer.line.strokeWidth = 2;
            valueAxis.renderer.line.stroke = am4core.color("#C61AFC");
            valueAxis.renderer.labels.template.fill = am4core.color("#C61AFC");

            let valueAxisConsumed = x.yAxes.push(new am4charts.ValueAxis());
            valueAxisConsumed.title.text = `${chartUnit.toUpperCase()} Movement`
            valueAxisConsumed.renderer.opposite = true;
            valueAxisConsumed.renderer.line.strokeOpacity = 1;
            valueAxisConsumed.renderer.line.strokeWidth = 2;
            valueAxisConsumed.renderer.line.stroke = am4core.color("#717d7e");
            valueAxisConsumed.renderer.labels.template.fill = am4core.color("#717d7e");

            let lineSeries = x.series.push(new am4charts.LineSeries());
            lineSeries.name = "Fuel Consumed";
            lineSeries.dataFields.valueY = "quantity";
            lineSeries.dataFields.categoryX = "date";

            lineSeries.strokeWidth = 2;
            lineSeries.propertyFields.strokeDasharray = "lineDash";
            lineSeries.tooltip.label.textAlign = "middle";
            lineSeries.yAxis = valueAxis;
            lineSeries.stroke = am4core.color("#C61AFC");
            // lineSeries.legendSettings.labelText = `Distance. (Total: ${totaldistance_travelled.toFixed(2)} Kms.)`;

            let bullet = lineSeries.bullets.push(new am4charts.Bullet());
            bullet.fill = am4core.color("#fff"); // tooltips grab fill from parent by default
            bullet.tooltipText = "[#C61AFC font-size: 11px]{name} in {dateX}:\n[/][#C61AFC font-size: 15px]{valueY}[/] [#C61AFC]{additional}[/]"
            let circle = bullet.createChild(am4core.Circle);
            circle.radius = 2;
            circle.fill = am4core.color("#fff");
            circle.strokeWidth = 1;

            let lineSeriesConsumed = x.series.push(new am4charts.LineSeries());
            lineSeriesConsumed.name = `${chartUnit.toUpperCase()} Consumed`;
            lineSeriesConsumed.dataFields.valueY = chartUnit === 'hours' ? 'hours_consumed' : 'kms_consumed';
            lineSeriesConsumed.dataFields.categoryX = "date";

            lineSeriesConsumed.stroke = am4core.color("#717d7e");
            lineSeriesConsumed.strokeWidth = 1;
            lineSeriesConsumed.propertyFields.strokeDasharray = "lineDash";
            lineSeriesConsumed.tooltip.label.textAlign = "middle";
            lineSeriesConsumed.yAxis = valueAxisConsumed;
            // lineSeriesConsumed.legendSettings.labelText = `Distance. (Total: ${totaldistance_travelled_effective.toFixed(2)} Kms.)`;

            let bulletConsumed = lineSeriesConsumed.bullets.push(new am4charts.Bullet());
            bulletConsumed.fill = am4core.color("#fff"); // tooltips grab fill from parent by default
            bulletConsumed.tooltipText = "[#717d7e font-size: 11px]{name} in {dateX}:\n[/][#717d7e font-size: 15px]{valueY}[/] [#717d7e]{additional}[/]"

            let circleConsumed = bulletConsumed.createChild(am4core.Circle);
            circleConsumed.radius = 3;
            circleConsumed.fill = am4core.color("#fff");
            circleConsumed.strokeWidth = 1;

            x.legend = new am4charts.Legend();

            // Add cursor
            x.cursor = new am4charts.XYCursor();
            x.cursor.fullWidthLineX = true;
            x.cursor.xAxis = dateAxis;
            x.cursor.lineX.strokeOpacity = 0;
            x.cursor.lineX.fill = am4core.color("#000");
            x.cursor.lineX.fillOpacity = 0.1;

            // Add scrollbar
            if (data && data.length > 25) {
                let scrollbarX = new am4charts.XYChartScrollbar();
                scrollbarX.series.push(lineSeries);
                scrollbarX.series.push(lineSeriesConsumed);
                // scrollbarX.marginBottom = 50;
                x.scrollbarX = scrollbarX;
            }
            x.cursor = new am4charts.XYCursor();
            x.data = data;

            chart.current = x;

            return () => {
                if (x)
                    x.dispose();
            };
        }
    }, [data, header, chartUnit]);

    useLayoutEffect(() => {
        if (chart && chart.current)
            chart.current.paddingRight = props.paddingRight;
    }, [props.paddingRight]);

    return <Card>
        {loading ? (
            <div style={{ width: "100%", height: "500px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                Loading ...
            </div>
        ) : data && data.length ? (
            <div id="fuelConsumed" style={{ width: "100%", height: "500px" }} />
        ) : (
            <div style={{ width: "100%", height: "500px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Empty />
            </div>
        )}
    </Card>

}

export default FuelConsumptionChart;